import useApiQuery from 'shared/hooks/use-api-query';
import {DeliveryManBillingProps} from '../types';
import deliveryManBillingsKeys from '../util/delivery-man-billings-keys';

const useDeliveryManBilling = (deliveryManBillingId: string) => {
  return useApiQuery<DeliveryManBillingProps>({
    url: `/delivery-man-billings/${deliveryManBillingId}`,
    queryKey: deliveryManBillingsKeys.details(deliveryManBillingId),
  });
};

export default useDeliveryManBilling;
